import { createApi } from '@reduxjs/toolkit/query/react';
import { TGetDBCVersionsQuery, TGetDBCVersionsResponse } from '../../../../../../shared/types/metadataTypes';
import { networkBaseQuery } from './utils';

export const projectMetadataApi = createApi({
  reducerPath: 'projectMetadataApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getDBCVersions: builder.query<TGetDBCVersionsResponse, TGetDBCVersionsQuery | void>({
      query: (params) => ({ url: '/api/metadata/dbc-versions', params: params ?? {} }),
      keepUnusedDataFor: Number.POSITIVE_INFINITY
    })
  })
});

export const { useGetDBCVersionsQuery } = projectMetadataApi;
